import moment from "moment";
import { MoveArbetsorderOperationCommand } from "~app/features/planera/commands/MoveArbetsorderOperationCommand";
import { Operation } from "./Operation";
export class OperationShifter {

    constructor(private readonly operationer: Operation[], private readonly helgdagCalculator: (date: string | moment.Moment) => boolean) {
    }

    shiftDays(daysShifted: number) {
        // Första operationen shiftas med daysShifted. Resterande shiftas med
        const commands: MoveArbetsorderOperationCommand[] = [];
        const firstOperation = this.operationer[0];
        firstOperation.shiftDays(daysShifted);
        let prevOperation = firstOperation;

        commands.push(new MoveArbetsorderOperationCommand((instance) => {
            instance.arbetsorderId = firstOperation.arbetsorderId;
            instance.operationId = firstOperation.operationId;
            instance.startdatum = firstOperation.startDate;
        }));

        this.operationer.slice(1).forEach((operation) => {
            // Startdate för efterkommande ska inte vara på helgdag
            // nextDate är vad som efter mutering ska bli vår starttid

            // Initieras till föregående operations sluttid
            let nextDate = moment(prevOperation.endDate);

            let workdayOffsetRemaining = operation.workdayOffset;

            while (workdayOffsetRemaining !== 0) {
                const sign = workdayOffsetRemaining > 0 ? 1 : -1;

                let addedWorkday = false;
                while (this.helgdagCalculator(nextDate)) {
                    nextDate = nextDate.add(sign * 1, "d");

                    if (sign < 0) {
                        // Om vi går bakåt i tiden över en helgdag så får vi automatiskt en tillagd arbetsdag
                        addedWorkday = true;
                    }
                }

                if (!addedWorkday) {
                    // Lägg inte till dubbla arbetsdagar i ett steg
                    nextDate = nextDate.add(sign * 1, "d");
                }

                workdayOffsetRemaining += sign * -1;
            }

            // Räkna helgdagar så vi inte startar på någon sån
            while (this.helgdagCalculator(nextDate)) {
                nextDate = nextDate.add(1, "d");
            }

            const startDate = nextDate;

            operation.setStartingDate(startDate);
            commands.push(new MoveArbetsorderOperationCommand((instance) => {
                instance.arbetsorderId = operation.arbetsorderId;
                instance.operationId = operation.operationId;
                instance.startdatum = operation.startDate;
            }));

            prevOperation = operation;
        });

        return commands;
    }
}
